import { FulfillmentStep as FulfillmentStepIndication } from '@studyportals/sp-lord-business-interface';

export default FulfillmentStepIndication;
